<template>
  <div class="app-container">
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="handleAdd(true)"
          
        >新增</el-button>
      </el-col>
      <!-- // 批量删除1 -->
      <el-col :span="1.5">
        <el-button type="danger"
          plain
          icon="el-icon-delete"
          size="mini"
          @click="handleDeleteAll">删除</el-button>
      </el-col>
      <!-- <el-col :span="1.5">
        <el-button
          type="danger"
          plain
          icon="el-icon-delete"
          size="mini"
          
          @click="handleDelete"
          
        >删除</el-button>
      </el-col> -->
      <!-- <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar> -->
    </el-row>
    <el-table v-loading="loading" :data="userList"  @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="名称" prop="Name" />
      <el-table-column label="AppId" prop="AppId" :show-overflow-tooltip="true"  />
      <el-table-column label="秘钥" prop="AppSecret" :show-overflow-tooltip="true"  />
      <el-table-column label="IpList" prop="IpList" :show-overflow-tooltip="true"  />
      <el-table-column label="状态" prop="State" :show-overflow-tooltip="true"  >
        <template slot-scope="scope">
          <span>{{scope.row.State==1?'正常':'锁定'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="280"  align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope" >
          <el-button
            size="mini"
            type="text"
            icon="el-icon-tickets"
            @click="handleDetail(scope.row)"
           
          >详情</el-button>
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
           
          >编辑</el-button>
          <el-button
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
            
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      v-show="total>0"
      :total="total"
      :page-sizes="[2, 5, 10, 15]"
      layout="total, sizes, prev, pager, next, jumper"
      :page.sync="queryParams.pageIndex"
      :limit.sync="queryParams.pageSize"
      @pagination="handleQuery"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage1"
    />
      <!-- 详情 -->
      <el-dialog title="详情"  class="openDialog" :visible.sync="detailOpen" width="650px" append-to-body>
        <el-form  label-width="100px">
          <el-col :span="12">
          <el-form-item label="名称:" >
            {{form.Name}}
          </el-form-item>
        </el-col>
          <el-col :span="12">
          <el-form-item label="AppId:">
            {{form.AppId}}
          </el-form-item>
        </el-col>
          <el-col :span="12">
          <el-form-item label="秘钥:" >
            {{form.AppSecret}}
          </el-form-item>
        </el-col>
          <el-col :span="12">
          <el-form-item label="IpList:">
            {{form.IpList}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="AI角色:">
            {{form.AIRole}}
          </el-form-item>
        </el-col>
          <el-col :span="12">
          <el-form-item label="状态:" >
            {{form.State==1?'正常':'锁定'}}
          </el-form-item>
        </el-col>
          <el-col :span="12">
          <el-form-item label="备注:">
            {{form.Remark}}
          </el-form-item>
        </el-col>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelDetail">取 消</el-button>
        </div>
      </el-dialog>
      <!-- 添加或修改角色配置对话框 -->
      <el-dialog :title="title" :visible.sync="open" width="800px" append-to-body class="search2">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-col :span="12">
        <el-form-item label="名称" prop="Name">
          <el-input v-model="form.Name" placeholder="请输入名称" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item  label="AppId" prop="AppId">
          <el-input v-model="form.AppId" placeholder="请输入AppId" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item  label="IpList" prop="IpList">
          <el-input v-model="form.IpList" placeholder="请输入IpList" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="秘钥" prop="AppSecret">
          <el-input v-model="form.AppSecret" placeholder="请输入秘钥" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="AI角色" prop="AIRole">
          <el-input v-model="form.AIRole" placeholder="请输入AI角色" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="状态" prop="State">
          <el-switch v-model="form.State"  active-text="锁定" inactive-text="正常"  :active-value="2"
    :inactive-value="1" placeholder="请输入AI角色" />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="备注" prop="Remark">
          <el-input type="textarea" v-model="form.Remark" placeholder="请输入备注" />
        </el-form-item>
      </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { addAppInfo,listAppInfo,editAppInfo,deleteAppInfo,detailAppInfo } from "@/api/appInfo.js";
// import { listCompany } from "@/api/company.js";
// import { listRole } from "@/api/role.js";

export default {
  name:"app",
  data(){
    return{
      passform:{
        newPwd:'',
        Account:'',
        Id:''
      },
      companyList:[],
      currentPage1:1,
      defaultProps: {
        children: "children",
        label: "RoleName",
        disabled:function(data, node) {
          // 禁用回收站选项
          if (data.IsEnable === true) {
            return false
          }else{
            return true
          }
        }
      },
      queryParams:{
        pageIndex: 1,
        pageSize: 10,
        roleName: undefined,
      },
      loading:false,
      userList:[],
      total:0,
      open:false,
      detailOpen:false,
      title:'设置角色',
      form:{
      },
      rules: {
        Name: [
          { required: true, message: "名称不能为空", trigger: "blur" }
        ],
        AppId: [
          { required: true, message: "AppId不能为空", trigger: "blur" }
        ],
        IpList: [
          { required: true, message: "IpList不能为空", trigger: "blur" }
        ],
        AppSecret: [
          { required: true, message: "秘钥不能为空", trigger: "blur" }
        ]
      },
      deptOptions:[],
      multipleSelection:[],
      Id:"",
    }
  },
  methods:{
    generatePassword() {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&amp;*()_+{}[]|\\;:\'&quot;,./&lt;&gt;?';
      let password = '';
      for (let i = 0; i < 8; i++) {
        const randomIndex = Math.floor(Math.random() * chars.length);
        password += chars[randomIndex];
      }
      return password;
    },

    randomPwd(){
      this.passform.newPwd=this.generatePassword()
    },
     // 批量删除1
     handleSelectionChange(val) {
      // this.copyTable = val; // 选择的数据存储到copyData中
      this.multipleSelection = val.map((item) => item.Id);
      // console.log(0,this.multipleSelection)
    },
    // 批量删除1
    handleDeleteAll () {
      var obj = this.multipleSelection
      if(obj.length==0){
        this.$message.error('请选择数据')
        return
      }
      this.$confirm('此操作将永久删除选中的用户信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
          var obj = this.multipleSelection
          // 批量删除1
          const [res, err] = await deleteAppInfo(obj)
        
          this.handleQuery()

      })
    },
    formatt2(val){
      return val?.split('T')[0]+" "+val?.split('T')[1]
    },
    handleSizeChange(val) {
      this.queryParams.pageSize=val
      this.handleQuery()
    },
    handleCurrentChange(val) {
      this.queryParams.pageIndex=val
      this.handleQuery()
    },
    async handleQuery(){
      const [res,err]=await listAppInfo({name:this.queryParams.name,pageSize:this.queryParams.pageSize,pageIndex:this.queryParams.pageIndex})
  
      this.userList=res.data.Data
      this.total=res.data.TotalCount
      
    },
    handleAdd(){
      
      this.title='新增'
      this.open=true
      this.form={}
      // 
    },
    async handleDetail(row){
      this.detailOpen=true
      const [res,err]=await detailAppInfo(row.Id)
      let rowData=res.data.Data
      this.form=rowData
    },
    cancelDetail(){
      this.detailOpen=false
    },
    handleUpdate(row){
      
      this.title='编辑'
      this.open=true
      this.$set(this,'form',{...row})
      this.resetForm()
    },
    handleDelete(row){
      this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const [res,err]=await deleteAppInfo(row.Id)
        
          this.handleQuery()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    resetForm() {
        this.$refs.form?.resetFields();
      },
    submitForm(){
      if(!this.form.Remark){
        this.form.Remark=''
      }
      this.$refs.form.validate(async (valid)=>{
        if (valid) {
          if(this.form.Id){
            let item=JSON.parse(JSON.stringify(this.form))
            const [res,err]=await editAppInfo(item)
          }else{
            const [res,err]=await addAppInfo(this.form)
          }
          this.handleQuery()
          this.open=false
        }
      })
    },
    cancel(){
      this.resetForm()
      this.open=false
    },
    
  },
  async mounted(){
    // this.getlistCompany()
    this.handleQuery()
  }
}
</script>

<style scoped>
@import "../../assets/style/common.css";
:deep(.search2 .el-date-editor--daterange.el-input__inner){
  width:150px !important;
}
:deep(.search2 .el-input){
  width:150px !important;
}
.code{
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
}
.codeInput{
  height: 50px;
  background-color: #fff;
  width: 230px;
  line-height: 50px;
}
.codeBtn{
  margin-left: 10px;
}
:deep(.el-dialog__body){
  height: 240px;
}
</style>